import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=0d6f91ad&"
import script from "./SliderComponent.vue?vue&type=script&lang=js&"
export * from "./SliderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports